"use strict";import{IconCross300 as o}from"../src/elements/IconCross300.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cross300",o);
//# sourceMappingURL=sp-icon-cross300.js.map
